var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDishwasher(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dishwasher",
    clipPath: "url(#clip0_321_860)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "dishwasher_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\xC3\xA9 895",
    d: "M2.06348 18.5303V1.84598C2.06348 1.44659 2.22213 1.06356 2.50454 0.781153C2.78695 0.498744 3.16998 0.340088 3.56937 0.340088H20.4305C20.8299 0.340088 21.2129 0.498744 21.4953 0.781153C21.7777 1.06356 21.9364 1.44659 21.9364 1.84598V18.5303",
    stroke: "black",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\xC3\xA9 896",
    d: "M21.9364 21.6305V22.1542C21.9364 22.5535 21.7777 22.9366 21.4953 23.219C21.2129 23.5014 20.8299 23.6601 20.4305 23.6601H3.56937C3.16998 23.6601 2.78695 23.5014 2.50454 23.219C2.22213 22.9366 2.06348 22.5535 2.06348 22.1542V21.6305",
    stroke: "black",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe 1232"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe 1229"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\xC3\xA9 897",
    d: "M10.3412 9.61248C9.18487 9.2043 7.91852 9.23729 6.78497 9.70515C5.65142 10.173 4.73044 11.0428 4.1986 12.1478C3.66676 13.2528 3.56148 14.5152 3.90294 15.693C4.2444 16.8708 5.00858 17.8811 6.04897 18.5303",
    stroke: "black",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\xC3\xA9 898",
    d: "M8.03292 17.3129C7.34617 17.1639 6.73112 16.7844 6.29003 16.2373C5.84894 15.6903 5.6084 15.0087 5.6084 14.306C5.6084 13.6033 5.84894 12.9217 6.29003 12.3747C6.73112 11.8276 7.34617 11.4481 8.03292 11.2991",
    stroke: "black",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe 1230"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\xC3\xA9 899",
    d: "M13.6577 9.61248C12.5013 9.2043 11.2349 9.23729 10.1014 9.70515C8.96782 10.173 8.04685 11.0428 7.51501 12.1478C6.98317 13.2528 6.87788 14.5152 7.21935 15.693C7.56081 16.8708 8.32499 17.8811 9.36538 18.5303",
    stroke: "black",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\xC3\xA9 900",
    d: "M11.3493 17.3129C10.6626 17.1639 10.0475 16.7844 9.60644 16.2373C9.16535 15.6903 8.9248 15.0087 8.9248 14.306C8.9248 13.6033 9.16535 12.9217 9.60644 12.3747C10.0475 11.8276 10.6626 11.4481 11.3493 11.2991",
    stroke: "black",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe 1231"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\xC3\xA9 901",
    d: "M17.949 18.5302C18.8663 17.9581 19.5725 17.1028 19.9606 16.0937C20.3487 15.0847 20.3977 13.9766 20.1001 12.9372C19.8026 11.8978 19.1746 10.9836 18.3113 10.3327C17.448 9.68187 16.3963 9.32983 15.3151 9.32983C14.234 9.32983 13.1822 9.68187 12.3189 10.3327C11.4556 10.9836 10.8277 11.8978 10.5301 12.9372C10.2325 13.9766 10.2815 15.0847 10.6696 16.0937C11.0578 17.1028 11.7639 17.9581 12.6812 18.5302",
    stroke: "black",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\xC3\xA9 902",
    d: "M18.1308 13.0633C18.4331 13.747 18.4765 14.5172 18.2529 15.2305C18.0292 15.9438 17.5538 16.5514 16.9152 16.94C16.2766 17.3286 15.5185 17.4716 14.7822 17.3425C14.0459 17.2134 13.3818 16.8209 12.9135 16.2383C12.4452 15.6556 12.2049 14.9225 12.2373 14.1756C12.2696 13.4288 12.5725 12.7193 13.0895 12.1793C13.6064 11.6393 14.3021 11.3058 15.0468 11.2409C15.7915 11.176 16.5344 11.3841 17.1369 11.8265",
    stroke: "black",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\xC3\xA9 903",
    d: "M3.70508 18.5303V4.37787C3.70508 4.14288 3.79843 3.91751 3.9646 3.75134C4.13076 3.58517 4.35613 3.49182 4.59112 3.49182H19.4071C19.6421 3.49182 19.8675 3.58517 20.0337 3.75134C20.1998 3.91751 20.2932 4.14288 20.2932 4.37787V18.5303",
    stroke: "black",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\xC3\xA9 904",
    d: "M6.57326 21.6305H22.1451C22.3442 21.6301 22.5412 21.5904 22.725 21.5138C22.9087 21.4373 23.0756 21.3252 23.216 21.1841C23.3564 21.0429 23.4676 20.8755 23.5432 20.6914C23.6189 20.5073 23.6575 20.31 23.6569 20.1109V19.1821C23.6569 19.008 23.5877 18.8409 23.4645 18.7178C23.3413 18.5946 23.1743 18.5254 23.0001 18.5254H0.996606C0.822422 18.5254 0.655372 18.5946 0.532205 18.7178C0.409038 18.8409 0.339844 19.008 0.339844 19.1821V20.1109C0.339844 20.3098 0.379021 20.5068 0.455138 20.6906C0.531256 20.8743 0.642823 21.0413 0.78347 21.182C0.924117 21.3226 1.09109 21.4342 1.27485 21.5103C1.45862 21.5864 1.65557 21.6256 1.85448 21.6256H4.93038",
    stroke: "black",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 5911",
    d: "M13.0333 3.49182H10.9668V5.22894H13.0333V3.49182Z",
    stroke: "black",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\xC3\xA9 905",
    d: "M8.78533 5.22888H17.8624C18.0031 5.22888 18.1381 5.28477 18.2375 5.38425C18.337 5.48373 18.3929 5.61865 18.3929 5.75934V6.39376C18.3929 6.53445 18.337 6.66938 18.2375 6.76886C18.1381 6.86834 18.0031 6.92423 17.8624 6.92423H6.13788C5.99719 6.92423 5.86227 6.86834 5.76279 6.76886C5.66331 6.66938 5.60742 6.53445 5.60742 6.39376V5.75934C5.60742 5.61865 5.66331 5.48373 5.76279 5.38425C5.86227 5.28477 5.99719 5.22888 6.13788 5.22888H7.14245",
    stroke: "black",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\xC3\xA9 906",
    d: "M19.2276 19.908H17.4575C17.3286 19.908 17.2051 19.9591 17.114 20.0502C17.0229 20.1413 16.9717 20.2649 16.9717 20.3937V21.6315H19.7134V20.3937C19.7134 20.2649 19.6622 20.1413 19.5711 20.0502C19.48 19.9591 19.3564 19.908 19.2276 19.908Z",
    stroke: "black",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_321_860"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDishwasher);
export default __webpack_public_path__ + "static/media/dishwasher.504cc621e01413078ea70e711b5e9d98.svg";
export { ForwardRef as ReactComponent };